import React from 'react'

import { inject, observer } from 'mobx-react'

import Spinner from '~/client/src/shared/components/Spinner/Spinner'
import ClosuresStore from '~/client/src/shared/stores/domain/Closures.store'
import CompaniesStore from '~/client/src/shared/stores/domain/Companies.store'
import FormCategoriesStore from '~/client/src/shared/stores/domain/FormCategories.store'
import PermitTypesStore from '~/client/src/shared/stores/domain/PermitTypes.store'
import SitemapsStore from '~/client/src/shared/stores/domain/Sitemaps.store'

import Logistics from './Logistics'

interface IProps {
  sitemapsStore?: SitemapsStore
  permitTypesStore?: PermitTypesStore
  companiesStore?: CompaniesStore
  closuresStore?: ClosuresStore
  formCategoriesStore?: FormCategoriesStore
}

@inject(
  'sitemapsStore',
  'permitTypesStore',
  'companiesStore',
  'closuresStore',
  'formCategoriesStore',
)
@observer
export default class LogisticsContainer extends React.Component<IProps> {
  public render(): React.ReactNode {
    if (this.isLoading) {
      return (
        <div className="full-height row x-center y-center">
          <Spinner size="lg" className="loader" />
        </div>
      )
    }

    return <Logistics />
  }

  private get isLoading() {
    const {
      sitemapsStore,
      permitTypesStore,
      companiesStore,
      closuresStore,
      formCategoriesStore,
    } = this.props

    const isBaseLoading = [
      sitemapsStore,
      permitTypesStore,
      companiesStore,
      closuresStore,
      formCategoriesStore,
    ].some(store => !store.isDataReceived)

    return isBaseLoading
  }
}
